import { functionify } from '../function';

export function pipeline(...que) {
  return que.reduce((result, pipe) => functionify(pipe).call(null, result), null);
}
